let searchSession = {
    active: false,
    hadResultClick: false,
};

export function getSearchPageLocation() {
    if (typeof window === 'undefined') return '';
    return `${window.location.pathname}${window.location.search}`;
}

function trackSearchEvent(name, params) {
    if (typeof window === 'undefined' || typeof window.trackEventGlobalAndLocalGA4 !== 'function') {
        return;
    }

    const payload = {
        ga4_name: name,
        ga4_page_location: getSearchPageLocation(),
    };

    // The GA4 wrapper turns undefined into an empty string, so drop unset params instead.
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        payload[key] = value;
    });

    window.trackEventGlobalAndLocalGA4(payload);
}

export function trackSearchInitiated(searchTerm) {
    trackSearchEvent('search_initiated', { ga4_search_term: searchTerm });

    searchSession = { active: true, hadResultClick: false };
}

// Fires on the first keystroke of a search session, not on opening the search bar.
export function ensureSearchInitiated(searchTerm) {
    if (searchSession.active) return;

    trackSearchInitiated(searchTerm);
}

export function markSearchResultClick() {
    searchSession.hadResultClick = true;
}

export function endSearchSession() {
    searchSession = { active: false, hadResultClick: false };
}

export function trackSearchNoResults(searchTerm) {
    trackSearchEvent('search_no_results', { ga4_search_term: searchTerm });
}

export function trackSearchShowAll({ destinationUrl, searchTerm }) {
    trackSearchEvent('search_show_all', {
        ga4_destination_url: destinationUrl,
        ga4_search_term: searchTerm,
    });
}

const DESTINATION_TYPE_TO_EVENT = {
    content: 'search_to_content',
    pdp: 'search_to_pdp',
    plp: 'search_to_plp',
    search: 'search_to_historic',
};

const DESTINATION_TYPE_TO_RECOMMENDATION_TYPE = {
    content: 'content',
    pdp: 'product',
    plp: 'category',
    search: 'historic',
};

// Discover also sends recommendation fields on search_result_click; the measurement
// plan wants a plain position there.
const EVENTS_WITH_RECOMMENDATION_FIELDS = [
    'search_recommendation_click',
    'search_to_historic',
];

function trackSearchDestinationEvent(name, data) {
    const base = {
        ga4_destination_type: data.destinationType,
        ga4_destination_url: data.destinationUrl,
        ga4_search_term: data.searchTerm,
        ga4_product_name: data.productName,
        ga4_product_subcategory: data.productSubcategory,
        ga4_category: data.category,
        ga4_content_type: data.contentType,
    };

    if (EVENTS_WITH_RECOMMENDATION_FIELDS.indexOf(name) !== -1) {
        trackSearchEvent(name, {
            ...base,
            ga4_recommendation_position: data.position,
            ga4_recommendation_type:
                DESTINATION_TYPE_TO_RECOMMENDATION_TYPE[data.destinationType],
        });
        return;
    }

    trackSearchEvent(name, { ...base, ga4_position: data.position });
}

// Fires search_result_click, the destination event and search_completed, in that order.
export function trackSearchSuggestionClick(data) {
    markSearchResultClick();

    trackSearchDestinationEvent('search_result_click', data);

    const destinationEvent = DESTINATION_TYPE_TO_EVENT[data.destinationType];
    if (destinationEvent) {
        trackSearchDestinationEvent(destinationEvent, data);
    }

    if (data.destinationType === 'plp') {
        trackSearchDestinationEvent('search_recommendation_click', data);
    }

    trackSearchDestinationEvent('search_completed', data);
}

export function trackSearchAbandonedOnClose(searchTerm) {
    if (!searchSession.active || searchSession.hadResultClick) {
        endSearchSession();
        return;
    }

    trackSearchEvent('search_abandoned', { ga4_search_term: searchTerm });

    endSearchSession();
}
